import { Component, computed, effect, inject, ChangeDetectionStrategy } from '@angular/core';

import { MdwFade } from '@spaces-ui/animations/angular-css';

import { MdwAlertNotificationBase } from '../alert-notification-base/alert-notification-base';
import { MdwAlertNotificationsService } from '../alert-notifications-service';

@Component({
  selector: 'mdw-pending-alerts',
  templateUrl: './pending-alerts.html',
  styleUrls: ['./pending-alerts.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MdwFade],
})
export class MdwPendingAlerts extends MdwAlertNotificationBase {
  private alertNotificationsService = inject(MdwAlertNotificationsService);

  public isBottomPending?: boolean;

  public alertCount = computed(() => {
    const pending = this.isBottomPending
      ? this.alertNotificationsService.pendingBottomOverlays()
      : this.alertNotificationsService.pendingTopOverlays();

    return pending.length;
  });

  public constructor() {
    super();

    effect(() => {
      const alertCount = this.alertCount();

      if (alertCount === 0) {
        this.close();
      }
    });
  }
}
